export const GET_CHECKLIST = "GET_CHECKLIST"
export const GET_CHECKLIST_SUCCESS = "GET_CHECKLIST_SUCCESS"
export const GET_CHECKLIST_FAIL = "GET_CHECKLIST_FAIL"

export const ADD_CHECKLIST = "ADD_CHECKLIST"
export const ADD_CHECKLIST_SUCCESS = "ADD_CHECKLIST_SUCCESS"
export const ADD_CHECKLIST_FAIL = "ADD_CHECKLIST_FAIL"

export const UPDATE_CHECKLIST = "UPDATE_CHECKLIST"
export const UPDATE_CHECKLIST_SUCCESS = "UPDATE_CHECKLIST_SUCCESS"
export const UPDATE_CHECKLIST_FAIL = "UPDATE_CHECKLIST_FAIL"

export const DELETE_CHECKLIST = "DELETE_CHECKLIST"
export const DELETE_CHECKLIST_SUCCESS = "DELETE_CHECKLIST_SUCCESS"
export const DELETE_CHECKLIST_FAIL = "DELETE_CHECKLIST_FAIL"

export const SET_CHECKLIST_FIELD_ERRORS = "SET_CHECKLIST_FIELD_ERRORS"
